import React from 'react';

export const Plus = () => (
    <path d='M22.5,11H12V0.5C12,0.224,11.776,0,11.5,0S11,0.224,11,0.5V11H0.5C0.224,11,0,11.224,0,11.5S0.224,12,0.5,12H11v10.5
		c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V12h10.5c0.276,0,0.5-0.224,0.5-0.5S22.776,11,22.5,11z' />
);